import $ from 'jquery';
import Swiper from 'swiper/dist/js/swiper';
import { basketAdd } from "../queries";
import { updatePrices } from "../utilities";

$(document).on('click', '.ui-product__buy', async function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(this).hasClass('ui-button--disabled')) {
        return;
    }

    const $component = $(this).parents('.ui-product');
    const productId = +$component.attr('data-id');

    $component.addClass('ui-product--basket')
        .find('.ui-product-quantity')
        .trigger('set', 1);
    let isMobile = false;
    if (window.innerWidth <= 768) {
        isMobile = true
    }

    const response = await basketAdd(productId, isMobile);

    if (window.innerWidth <= 768) {
        $('.header-basket--mobile').replaceWith(response.component);
    } else {
        $('.header-basket').replaceWith(response.component);
    }
    // $('.header-basket').addClass('header-basket--opened');
    // setTimeout(() => {
    //     if (!$('.header-basket').hasClass('header-basket--hovered')) {
    //         $('.header-basket').removeClass('header-basket--opened');
    //     }
    // }, 2000);

    ym(56412904, 'reachGoal', 'basket-add');

    updatePrices();
});

$(document).on('change', '.ui-product-quantity', function (e, quantity) {
    if (+quantity < 1) {
        $(this).parents('.ui-product').removeClass('ui-product--basket');
    }
});


const sliders = {};
$(document).on('render', '.ui-product', function () {
    if ($(this).is(":hidden")) {
        return;
    }

    const id = $(this).attr('data-id');
    const $slider = $(this).find('.ui-product-preview-slider__container');

    if (sliders[id]) {
        return;
    }

    sliders[id] = new Swiper($slider, {
        speed: 600,
        nested: true,
        loop: false,
        autoplay: false,
        cache: false,
        slideClass: 'ui-product-preview-slider__slide',
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: {
            el: $(this).find('.swiper-pagination'),
            type: 'bullets',
            clickable: true,
        },
    });
});

$('.ui-product').trigger('render');
